<!-- quotation-login.component.html -->
<div class="login-page">
  <div class="split-container">
    <!-- Left Side - Static Image Section -->
    <div class="image-section">
      <div class="dashboard-image"></div>
      <div class="content-overlay">
        <div class="brand-content">
          <!-- Top Section - Title & Tagline -->
          <div class="brand-header">
            <h1 class="brand-title">Quotation Management System</h1>
            <p class="brand-tagline">Streamline your business with powerful quotation tools</p>
            <div class="brand-divider"></div>
          </div>
          <div class="brand-footer">
            <p class="brand-description">
              Transform the way you create, manage, and track quotations.
              Designed for modern businesses that value efficiency and precision.
            </p>
            <div class="features-list">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="pi pi-chart-line"></i>
                </div>
                <div class="feature-text">
                  <h3>Real-time Analytics</h3>
                  <p>Monitor performance and insights instantly</p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="pi pi-users"></i>
                </div>
                <div class="feature-text">
                  <h3>Team Collaboration</h3>
                  <p>Work together seamlessly across departments</p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="pi pi-file-edit"></i>
                </div>
                <div class="feature-text">
                  <h3>Smart Quotations</h3>
                  <p>Create professional quotes in minutes</p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="pi pi-shield"></i>
                </div>
                <div class="feature-text">
                  <h3>Secure Platform</h3>
                  <p>Enterprise-grade security you can trust</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Side - Login Form Section -->
    <div class="form-section">
      <!-- Success Notification Toast -->
      <div class="toast-notification" [class.show]="showSuccessToast" [class.success]="successType === 'login'"
        [class.info]="successType === 'reset'">
        <div class="toast-content">
          <div class="toast-icon">
            <i [class]="successType === 'login' ? 'pi pi-check-circle' : 'pi pi-shield'"></i>
          </div>
          <div class="toast-text">
            <div class="toast-title">{{ successMessage }}</div>
            <div class="toast-subtitle">{{ successSubtitle }}</div>
          </div>
          <button class="toast-close" (click)="closeToast()">
            <i class="pi pi-times"></i>
          </button>
        </div>
        <div class="toast-progress" [class.animate]="showSuccessToast"></div>
      </div>

      <div class="form-container">
        <!-- Logo for smaller screens -->
        <div class="mobile-logo">
          <div class="logo-icon">
            <i class="pi pi-building"></i>
          </div>
        </div>

        <div class="form-header">
          <img src="../../../../assets/quotation-dashboard/kikblox.png" alt="Logo" class="header-logo" />
          <h1 class="form-title">Welcome Back</h1>
          <p class="form-subtitle">Sign in to continue to your account</p>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
          <!-- Employee Number Field -->
          <div class="form-group">
            <label for="employeeNumber" class="form-label">
              <i class="pi pi-user"></i>
              Employee Number
            </label>
            <div class="input-wrapper">
              <input type="text" id="employeeNumber" formControlName="employeeNumber"
                placeholder="Enter your employee number" class="form-input"
                [class.error]="loginForm.get('employeeNumber')?.invalid && loginForm.get('employeeNumber')?.touched" />
              <span class="input-focus-border"></span>
            </div>
            <div class="error-message"
              *ngIf="loginForm.get('employeeNumber')?.invalid && loginForm.get('employeeNumber')?.touched">
              <i class="pi pi-exclamation-circle"></i>
              Employee number must be 1-10 digits
            </div>
          </div>

          <!-- Password Field -->
          <div class="form-group">
            <label for="password" class="form-label">
              <i class="pi pi-lock"></i>
              Password
            </label>
            <div class="input-wrapper">
              <input [attr.type]="showPassword ? 'text' : 'password'" id="password" formControlName="password"
                placeholder="Enter your password" class="form-input password-input"
                [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" />
              <button type="button" class="password-toggle" (click)="togglePasswordVisibility()" tabindex="-1">
                <i [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
              </button>
              <span class="input-focus-border"></span>
            </div>
            <div class="error-message" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
              <i class="pi pi-exclamation-circle"></i>
              Password must be at least 6 characters
            </div>
          </div>

          <!-- Remember Me & Forgot Password -->
          <div class="form-options">
            <label class="checkbox-container">
              <input type="checkbox" [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}">
              <span class="checkmark">
                <i class="pi pi-check"></i>
              </span>
              <span class="checkbox-label">Remember me</span>
            </label>
            <a href="#" class="forgot-link" (click)="onForgotPassword($event)">
              Forgot password?
            </a>
          </div>

          <!-- Server Error Message -->
          <div class="alert-error" *ngIf="errorMessage">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ errorMessage }}</span>
          </div>

          <!-- Submit Button -->
          <button type="submit" class="submit-btn" [disabled]="loginForm.invalid || isLoading">
            <span class="btn-text" *ngIf="!isLoading">
              <span>Sign In</span>
              <i class="pi pi-arrow-right"></i>
            </span>
            <span class="btn-loader" *ngIf="isLoading">
              <span class="spinner"></span>
              <span>Signing in...</span>
            </span>
          </button>
        </form>

        <div class="form-footer">
          <p>Need help? <a href="#" class="support-link">Contact IT Support</a></p>
        </div>
      </div>

      <!-- Forgot Password Modal -->
      <div class="modal-backdrop" *ngIf="forgotPasswordMode" (click)="onBackToLogin()">
        <div class="modal-container" (click)="$event.stopPropagation()">
          <button class="modal-close" (click)="onBackToLogin()" type="button">
            <i class="pi pi-times"></i>
          </button>

          <div class="modal-header">
            <div class="modal-icon">
              <i class="pi pi-lock"></i>
            </div>
            <h2>{{ showOtpStep ? 'Verify & Reset' : 'Reset Password' }}</h2>
            <p>{{ showOtpStep ? 'Enter the code sent to your email' : 'Enter your employee number to receive a verification code' }}</p>
          </div>

          <div class="modal-body">
            <!-- Step 1: Employee Number -->
            <div *ngIf="!showOtpStep" class="reset-step">
              <div class="form-group">
                <label for="resetEmployeeNumber" class="form-label">
                  <i class="pi pi-user"></i>
                  Employee Number
                </label>
                <div class="input-wrapper">
                  <input id="resetEmployeeNumber" type="text" [(ngModel)]="resetEmployeeNumber"
                    placeholder="Enter employee number" class="form-input" [class.error]="employeeError"
                    autocomplete="off" name="reset-employee-number" inputmode="numeric" pattern="[0-9]*" />
                  <span class="input-focus-border"></span>
                </div>
                <div class="error-message" *ngIf="employeeError">
                  <i class="pi pi-exclamation-circle"></i> {{ employeeError }}
                </div>
              </div>

              <button type="button" class="submit-btn" (click)="sendResetEmail()"
                [disabled]="isLoading || !resetEmployeeNumber">
                <span class="btn-text" *ngIf="!isLoading">
                  <span>Send Code</span>
                  <i class="pi pi-send"></i>
                </span>
                <span class="btn-loader" *ngIf="isLoading">
                  <span class="spinner"></span>
                </span>
              </button>
            </div>

            <!-- Step 2: OTP + New Password -->
            <div *ngIf="showOtpStep" class="reset-step">
              <div class="form-group">
                <label for="resetOtp" class="form-label">
                  <i class="pi pi-key"></i>
                  Verification Code
                </label>
                <div class="input-wrapper">
                  <input id="resetOtp" type="text" [(ngModel)]="otpCode" maxlength="6" placeholder="Enter 6-digit code"
                    class="form-input text-center" [class.error]="otpError" autocomplete="off" name="otp-code"
                    inputmode="numeric" pattern="[0-9]*" />
                  <span class="input-focus-border"></span>
                </div>
              </div>

              <div class="form-group">
                <label for="newPassword" class="form-label">
                  <i class="pi pi-lock"></i>
                  New Password
                </label>
                <div class="input-wrapper">
                  <input id="newPassword" [attr.type]="showPassword ? 'text' : 'password'" [(ngModel)]="newPassword"
                    placeholder="Enter new password" class="form-input password-input" [class.error]="otpError"
                    autocomplete="new-password" name="new-password-reset" />
                  <button type="button" class="password-toggle" (click)="togglePasswordVisibility()">
                    <i [class]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
                  </button>
                  <span class="input-focus-border"></span>
                </div>
              </div>

              <div class="error-message" *ngIf="otpError">
                <i class="pi pi-exclamation-circle"></i> {{ otpError }}
              </div>

              <button type="button" class="submit-btn" (click)="resetPassword()"
                [disabled]="isLoading || otpCode.length !== 6 || newPassword.length < 6">
                <span class="btn-text" *ngIf="!isLoading">
                  <span>Reset Password</span>
                  <i class="pi pi-check"></i>
                </span>
                <span class="btn-loader" *ngIf="isLoading">
                  <span class="spinner"></span>
                </span>
              </button>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="back-btn" (click)="onBackToLogin()">
              <i class="pi pi-arrow-left"></i>
              Back to Sign In
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>